import React, { Component } from 'react'
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {Col, Row, Button, Popover,} from "antd";
import {withRouter} from "react-router-dom";
import './TrashMultiSelectorHeader.css';
import menuVertical from "../../../assets/menu-vertical.svg";
class TrashMultiSelectorHeader extends Component {

  render() {
    const { 
      selectedFiles,
      onCancel,
      onSelectAll,
      onDelete,
      onRestore,
      onMove,
      onDownload,
      intl,
      visibleOptions,
      handleChangeVisibleOptions
    } = this.props;

    return (
      <>
        {selectedFiles.length > 0 && <div style={{
          width: '100%',
          height: 45,
          backgroundColor: '#E7E6E6',
          padding: 1,
          zIndex: 2,
          borderRadius: 5
        }}>
          <div className={'container'} style={{ height: 45, }}>
            <Row
              type={'flex'}
              justify={'space-between'}
              align={'middle'}
              style={{ height: '100%' }}
            >
              <Col span={16}>
                <span style={{ marginRight: 17, color: '#3598CD', fontSize: 15, fontWeight: 600, }}>
                  <img src="/images/icons/file-void-icon.png" alt="icon file void" style={{ marginRight: 10 }} />{intl.formatMessage({id: "trash-multi-selected1"})} {selectedFiles.length} {`${selectedFiles.length === 1 ? intl.formatMessage({id: "trash-multi-selected2"}) : intl.formatMessage({id: "trash-multi-selected3"})}`}
                </span>
                <Button
                  shape={'round'}
                  type={'primary'}
                  size={'small'}
                  style={{ marginRight: 17, }}
                  onClick={onCancel}
                >
                  {intl.formatMessage({ id: 'cancel_button' })}
                </Button>
                <Button
                  shape={'round'}
                  type={'primary'}
                  size={'small'}
                  onClick={onSelectAll}
                >
                  {intl.formatMessage({ id: 'select_all' })}
                </Button>
              </Col>
              <Col span={8}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'end'}}>
                  <Popover
                    onVisibleChange={handleChangeVisibleOptions}
                    id={'menu-options-multi-selector'}
                    placement={'bottomRight'}
                    visible={visibleOptions}
                    content={(
                      <ul>
                        <li onClick={onDelete}>
                          <img src="/images/icons/delete-asset-icon.svg" alt="delete icon" />
                          <span style={{ marginLeft: 5, }}>{intl.formatMessage({id: "trash-option-delete"})}</span>
                        </li>
                        <li onClick={onRestore}>
                          <img src="/images/icons/restore-asset-icon.svg" alt="restore icon" />
                          <span style={{ marginLeft: 5, }}>{intl.formatMessage({id: "trash-option-restore"})}</span>
                        </li>
                        <li onClick={onMove}>
                          <img src="/images/icons/move-asset-icon.svg" alt="move icon" />
                          <span style={{ marginLeft: 5, }}>{intl.formatMessage({id: "trash-option-move"})}</span>
                        </li>
                        <li onClick={onDownload}>
                          <img src="/images/icons/download-asset-icon.svg" alt="download icon" />
                          <span style={{ marginLeft: 5, }}>{intl.formatMessage({id: "trash-option-download"})}</span>
                        </li>
                      </ul>
                    )}
                  >
                    <img src={menuVertical} alt="menu" style = {{
                      width: '20px',
                      height: '20px',
                      borderRadius: 50,
                    }}/>
                  </Popover>
                </div>
              </Col>
            </Row>
          </div>
        </div>}
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    workspace: state.assetsFavorites.workspace,
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(TrashMultiSelectorHeader)));
